import React, {useState} from 'react'
import {useRef} from 'react';
import Divider from './frontend_components/Divider';
import VisDiv from './frontend_components/VisDiv';

const TextField = ({label, description, isError, style={}, errorMessage, type="text", descriptionDivider=true, suffix, prefix, ...props}) => {
  const ref = useRef(undefined);
  const borderError = isError && "red"
  
  return (
    <div>
      <VisDiv style={{marginTop:"10px"}} rules={[label]}>
        <h4>{label}:</h4>
      </VisDiv>
    
      <div style={{...style, display:"flex", alignItems:"center"}} className="text-input-container" >
          <div style={{marginRight: "10px"}}>
            {prefix}
          </div>
          <input
            className='text-input'
            style={{borderColor: borderError}}
            type ={type}
            ref={ref} 
            {...props}
          />
          <div style={{marginLeft: "10px"}}>
            {suffix}
          </div>
      
      </div>

      {isError && <p style={{color:borderError}}>{errorMessage}</p>}
      <p>{description}</p>
      <VisDiv rules={[description && descriptionDivider]}>
          <Divider/>
      </VisDiv>
    </div>
  )
}

export default TextField


